module.exports = __webpack_public_path__ + "static/media/Illus-Credit_1@3x.006d7e7a.png";